import React from "react";
import { Route, Switch } from "react-router-dom";
import { isA, isReporter } from "../../store/utility";

import RequestList from "./RequestList";
import Request from "./Request";
import EditRequest from "./EditRequest";
import ClientResponse from "./ClientResponse";

const Requests = () => (
  <Switch>
    <Route exact path="/requests" component={RequestList} />
    <Route exact path="/requests/:number" component={Request} />
    <Route exact path="/requests/:number/response" component={ClientResponse} />
    {isA() || isReporter ? (
      <Route exact path="/requests/:number/edit" component={EditRequest} />
    ) : null}
  </Switch>
);

export default Requests;



// WEBPACK FOOTER //
// ./src/containers/Request/Requests.js